module.exports = __webpack_public_path__ + "img/57.b80a4e5b.jpg";